import React, { useEffect, useState } from "react";
import "../../../assets/MOCK_OD/scss/modules/custom.scss";
import "../../../assets/MOCK_OD/scss/modules/anim.scss";
import Footer from '../../Includes/Layouts/UFC_DC_V2/Footer';
import FormMOCK_OD from "../../Forms/FormMOCK_OD";
import AdtopiaLoadLP from "../../../Utility/AdtopiaLoadLP";
import FbViewPixel from "../../../Utility/FbViewPixel";

const MOCK_OD = () => {
  return (
    <>
      <AdtopiaLoadLP pageType="LP" splitName="MOCK_OD" />
      <FbViewPixel />
      <div className='MOCK_OD'>
        <FormMOCK_OD />
        <Footer />
      </div>
    </>
  )
}

export default MOCK_OD;